import { render, staticRenderFns } from "./adminComponent.vue?vue&type=template&id=0f1e4695&scoped=true"
import script from "./adminComponent.vue?vue&type=script&lang=js"
export * from "./adminComponent.vue?vue&type=script&lang=js"
import style0 from "./adminComponent.vue?vue&type=style&index=0&id=0f1e4695&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1e4695",
  null
  
)

export default component.exports